import type { Transition } from 'framer-motion';

export const spring: Transition = { type: 'spring', duration: 0.3, bounce: 0 };

export const pageTransition = {
  initial: { opacity: 0, y: 8 },
  animate: { opacity: 1, y: 0 },
  exit: { opacity: 0, y: 8 },
  transition: { duration: 0.18, ease: 'easeOut' },
} as const;

export const staggerChild = (i: number) => ({ ...spring, delay: i * 0.06 });
